import { render } from "./SidenavList.vue?vue&type=template&id=58a66218"
import script from "./SidenavList.vue?vue&type=script&lang=js"
export * from "./SidenavList.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/Portal/portal-partner-cicd-staging@2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__